// Home.js limpio (sin logos de 3D Secure)
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import EventCalendar from '../components/EventCalendar';

export default function Home() {
  const [homeImages, setHomeImages] = useState([]);

  useEffect(() => {
    const q = collection(db, "homeImages");
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const images = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setHomeImages(images);
    });
    return () => unsubscribe();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <section className="section p-0">
        {homeImages.length > 0 ? (
          <Carousel interval={10000} fade style={{ height: '70vh' }}>
            {homeImages.map(image => (
              <Carousel.Item key={image.id} style={{ height: '70vh' }}>
                <div style={{ position: 'relative', height: '100%', overflow: 'hidden' }}>
                  <img
                    className="d-block w-100 h-100"
                    src={image.imageURL}
                    alt={image.caption || 'Slide'}
                    style={{ objectFit: 'cover', objectPosition: 'center center' }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '100px',
                    background: 'linear-gradient(to top, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%)'
                  }}></div>
                </div>
                {image.caption && (
                  <Carousel.Caption>
                    <h3>{image.caption}</h3>
                  </Carousel.Caption>
                )}
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div style={{ height: '70vh', background: '#ccc' }}></div>
        )}
      </section>

      <section className="section" style={{ marginTop: '-50px', position: 'relative', zIndex: 1 }}>
        <Container>
          <h2 className="section-title">Calendario de Eventos</h2>
          <EventCalendar />
        </Container>
      </section>
    </motion.div>
  );
}